import { GROQ_MODEL } from "./groq";
// src/services/groqSummarizer.js

/**
 * Summarize any content blob using the Groq summarizer endpoint.
 * @param {string} content - The content to summarize.
 * @returns {Promise<string>} - The summarized text.
 */
export async function summarizeContent(content) {
  const body = {
    model: GROQ_MODEL,
    messages: [
      { role: "system", content: "Summarize this vendor content for Field Notes. Be concise (1 short sentence). Output ONLY the summary, nothing else." },
      { role: "user", content: content }
    ],
    temperature: 0.3,
    max_completion_tokens: 256,
    top_p: 1,
    stream: false
  };
  try {
    const res = await fetch("https://bylolucjhzsbbouoalah.functions.supabase.co/groq-chat", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body)
    });
    if (!res.ok) {
      console.error('Groq summarizer API error:', res.status, res.statusText);
      throw new Error('Failed to summarize content');
    }
    const data = await res.json();
    return data?.choices?.[0]?.message?.content || "No summary returned.";
  } catch (err) {
    console.error('Groq summarizer fetch error:', err);
    return "No summary returned.";
  }
}
